export default "__VITE_ASSET__CQcJrnxG__"